import { useMsal } from "@azure/msal-react";
import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './LoginForm.css';

const LogoutButton = () => {
  const { instance } = useMsal();

  const handleLogout = async () => {
    //Clear local storage
    localStorage.clear();

    // Redirect user after logout
    await instance.logoutRedirect({
      account: instance.getAllAccounts()[0]
    });
  };

  return (
    <span className="badge logout" style={{ cursor: 'pointer', fontSize: '16px' }} onClick={handleLogout}>
      <FontAwesomeIcon icon={faRightFromBracket} />
    </span>
  );
};

export default LogoutButton;
